import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class TransientMarkerBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new TransientMarkerBox({
            uuid,
            graph,
            name: "TransientMarkerBox",
            pointerRules: {
                accepts: [Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
        }), constructor);
    }
    static ClassName = "TransientMarkerBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitTransientMarkerBox, this);
    }
    get owner() {
        return this.getField(1);
    }
    get position() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "owner",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.TransientMarkers, true),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "position",
                deprecated: false,
                pointerRules: NoPointers,
            }, "non-negative", "seconds"),
        };
    }
}
